import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'lokos-file',
    templateUrl: './file.component.html',
    styleUrl: './file.component.scss',
    standalone: false
})
export class FileComponent {
  @Input({ required: false }) label = '';
  @Input({ required: false }) value = '';
  @Input({ required: true }) required = false;
  @Input({ required: false }) control: FormControl = new FormControl();
  @Input({ required: false }) multiSelect = false;
  @Input({ required: true }) acceptFormat: string[] = [];

  @Output() onChangeFile = new EventEmitter<any>();

  afterFileSelect(event: Event): void {
      this.control.patchValue(event);
      this.onChangeFile.emit(event);
  }
}
